/* Collection description */
const collectionDescriptionText = document.querySelector('.collection-header__description .collection-header__text-item');
if (collectionDescriptionText) {
  const collectionDescriptionMore = document.querySelector('.collection-header__description .toggle-btn.more');
  const collectionDescriptionLess = document.querySelector('.collection-header__description .toggle-btn.less');

  function collectionDescriptionCheckOverflow() {
    collectionDescriptionText.classList.remove('expanded');

    const isOverflowing = collectionDescriptionText.scrollHeight > collectionDescriptionText.clientHeight + 2;

    if (isOverflowing) {
      collectionDescriptionMore.style.display = 'inline';
      collectionDescriptionLess.style.display = 'none';
    } else {
      collectionDescriptionMore.style.display = 'none';
      collectionDescriptionLess.style.display = 'none';
    }
  }

  collectionDescriptionMore.onclick = () => {
    collectionDescriptionText.classList.add('expanded');
    collectionDescriptionMore.style.display = 'none';
    collectionDescriptionLess.style.display = 'inline';
  };

  collectionDescriptionLess.onclick = () => {
    collectionDescriptionText.classList.remove('expanded');
    collectionDescriptionLess.style.display = 'none';
    collectionDescriptionMore.style.display = 'inline';
    collectionDescriptionCheckOverflow();
  };

  collectionDescriptionCheckOverflow();

  window.addEventListener('resize', collectionDescriptionCheckOverflow);
}

/* Collection menu */
const shortcuts = document.querySelector('.collection-header .submenu');

if (shortcuts) {
    let shortcutsIsDown = false;
    let shortcutsStartX;
    let shortcutsDcrollLeft;

    shortcuts.addEventListener('mousedown', (e) => {
    shortcutsIsDown = true;
    shortcutsStartX = e.pageX - shortcuts.offsetLeft;
    shortcutsDcrollLeft = shortcuts.scrollLeft;
    });

    shortcuts.addEventListener('mouseleave', () => {
    shortcutsIsDown = false;
    });

    shortcuts.addEventListener('mouseup', () => {
    shortcutsIsDown = false;
    });

    shortcuts.addEventListener('mousemove', (e) => {
    if (!shortcutsIsDown) return;
    e.preventDefault();
    const x = e.pageX - shortcuts.offsetLeft;
    const walk = (x - shortcutsStartX) * 1;
    shortcuts.scrollLeft = shortcutsDcrollLeft - walk;
    });

    shortcuts.addEventListener('touchstart', (e) => {
    shortcutsIsDown = true;
    shortcutsStartX = e.touches[0].pageX - shortcuts.offsetLeft;
    shortcutsDcrollLeft = shortcuts.scrollLeft;
    });

    shortcuts.addEventListener('touchend', () => {
    shortcutsIsDown = false;
    });

    shortcuts.addEventListener('touchmove', (e) => {
    if (!shortcutsIsDown) return;
    const x = e.touches[0].pageX - shortcuts.offsetLeft;
    const walk = (x - shortcutsStartX) * 1;
    shortcuts.scrollLeft = shortcutsDcrollLeft - walk;
    });
}

/* product slider mobile */
const productSliderItems = document.querySelectorAll('#productMediaMobile .swiper-slide');
const productSliderProgress = document.querySelector('.product-single .slider-progress');

if (productSliderItems && productSliderProgress) {
    const productSliderProgressWidth = 100 / productSliderItems.length;
    
    productSliderProgress.style.width = productSliderProgressWidth + '%';

    function productSliderProgressUpdate() {
        productSliderItems.forEach((slide, index) => {
            if (slide.classList.contains('swiper-slide-active')) {
                productSliderProgress.style.left = (index * productSliderProgressWidth) + '%';
            }
        });
    }

    const productSliderWrapper = document.querySelector('#productMediaMobile .swiper-wrapper');
    const observer = new MutationObserver(productSliderProgressUpdate);
    observer.observe(productSliderWrapper, { attributes: true, subtree: true, attributeFilter: ['class'] });

    productSliderProgressUpdate();
}

/* header scroll up / down */
let lastScroll = 0;
let header;

window.addEventListener('scroll', () => {
  header = document.querySelector('.sticky-header');
  if (header) {
    const current = window.pageYOffset;
    
    if (current > lastScroll || current == 0) header.classList.remove('scroll-up');
    else header.classList.add('scroll-up');

    lastScroll = current;
  }
});

/* repair / return */
const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwO6SiGswDjLpMpUFtSRliwkxFO6L4wqSU0lBA_QrpjCs1yd7Q8y-9BiOsnMbl4pkNy/exec';

function serializeForm(form) {
  const data = new FormData(form);
  const obj = {};

  data.forEach((value, key) => {
    obj[key] = value;
  });

  return obj;
}

function handleFormSubmit(formId) {
  const form = document.getElementById(formId);
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    form.classList.add('loading');

    const params = new URLSearchParams(serializeForm(form)).toString();
    const url = `${GOOGLE_SCRIPT_URL}?${params}`;

    fetch(url, {method: 'GET', mode: 'cors'})
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then((data) => {
        if (data.result === 'error') {
          form.classList.add('fail');
        } else {
          form.classList.add('done');
        }
      })
      .catch(() => {
        form.classList.add('fail');
      })
      .finally(() => {
        form.classList.remove('loading');
      });
  });
}

handleFormSubmit('repair_form');
handleFormSubmit('return_form');

/* find in store */
document.addEventListener('click', (e) => {
  if (e.target.closest('.call-find-in-store-drawer')) {
    document.body.classList.add('js-drawer-open-find-in-store');
    loadFindInStore();
  } else if (e.target.closest('.drawer-find-in-store .close') || e.target.closest('.drawer-find-in-store .overlay')) {
    document.body.classList.remove('js-drawer-open-find-in-store');
  }
});

function loadFindInStore() {
  let fisContent = document.querySelector('#find-in-store-content');
  
  if (fisContent) {
    let fisContentSelect = fisContent.querySelector('.select');
    let fisContentResults = fisContent.querySelector('.results');
    let fisContentResultsData = fisContentResults.querySelector('.data');
    let fisContentResultsAvailable = fisContentResults.querySelector('.available');
    let fisContentResultsAvailableCount = fisContentResultsAvailable.querySelector('.count');
    let fisContentResultsAvailableS = fisContentResultsAvailable.querySelector('.s');
    let fisContentResultsNotAvailable = fisContentResults.querySelector('.not-available');
    let fisContentStores = fisContent.querySelectorAll('.stores > div');

    fisContentSelect.addEventListener('change', FisChangeStore);

    fisContentSelect.innerHTML = '';
    fisContentResultsData.innerHTML = '';
    fisContentResultsAvailable.style.display = 'none';
    fisContentResultsAvailableS.style.display = 'none';
    fisContentResultsNotAvailable.style.display = 'none';
    if (fisContentStores) {
      fisContentStores.forEach((fisContentStore) => {
        fisContentStore.style.display = 'none';
      });
    }

    let productHandle = fisContent.dataset.product;
    const query = `
      query {
        product(handle: "${productHandle}") {
          variants(first: 100) {
            edges {
              node {
                id
                title
                selectedOptions {
                  name
                  value
                }
                storeAvailability(first: 100) {
                  edges {
                    node {
                      available
                      location {
                        id
                        name
                        address {
                          address1
                          city
                          zip
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
    
    fetch("/api/2026-01/graphql.json", {method: "POST", headers: {"Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": "01823b7c903358bb319cd059816f67a4"}, body: JSON.stringify({ query })})
      .then((res) => res.json())
      .then((data) => {
        if (data.data.product) {
          const variants = data.data.product.variants.edges;
          let results = [];
          variants.forEach(({ node }) => {
            const variantId = String(node.id).split('/').pop();
            const selectedOptions = node.selectedOptions;
            
            let optionName, optionValue;
            selectedOptions.forEach(( option ) => {
              let optionName = String(option.name).toLowerCase();
              if (optionName == 'size' || optionName == 'taille') {
                optionValue = String(option.value);
              }
            });

            const available = node.storeAvailability.edges.some(({ node }) => node.available);

            let stores = [];
            if (available) {
              node.storeAvailability.edges.forEach(( storeItem ) => {
                if (storeItem.node.available)
                  stores.push([storeItem.node.location.name, storeItem.node.location.address.address1, storeItem.node.location.address.zip, storeItem.node.location.address.city]);
              });
            }

            results.push([optionValue, available, stores])
          });

          if (fisContent) {
            results.forEach(result => {
              const resultSize = result[0];
              const resultAvailable = result[1];
              const resultStores = result[2];

              let option = document.createElement('option');
              option.value = resultSize;
              option.textContent = resultSize;
              fisContentSelect.appendChild(option);

              let span = document.createElement('span');
              span.classList.add('r');
              span.dataset.size = resultSize;
              
              let sStores = '';
              if (resultStores.length > 0) {
                let loop = 0;
                resultStores.forEach(resultStore => {
                  if (loop > 0) sStores += `***`;
                  sStores += `${resultStore[0]}`;
                  loop++;
                });
              }

              span.dataset.stores = sStores;
              fisContentResultsData.appendChild(span);
            });

            FisChangeStore();
          }
        }
      });
  }
}

function FisChangeStore() {
  let fisContentSelect = document.querySelector('#find-in-store-content .select');
  let fisContentResultsAvailable = document.querySelector('#find-in-store-content .results .available');
  let fisContentResultsAvailableCount = document.querySelector('#find-in-store-content .results .count');
  let fisContentResultsAvailableS = document.querySelector('#find-in-store-content .results .s');
  let fisContentResultsNotAvailable = document.querySelector('#find-in-store-content .results .not-available');

  fisContentResultsAvailable.style.display = 'none';
  fisContentResultsAvailableS.style.display = 'none';
  fisContentResultsNotAvailable.style.display = 'none';

  if (fisContentSelect) {
    let value = fisContentSelect.value;

    let fisContentStores = document.querySelectorAll('#find-in-store-content .stores > div');
    if (fisContentStores) {
      fisContentStores.forEach((fisContentStore) => {
        fisContentStore.style.display = 'none';
      });
    }
    
    let fisContentStoreSpan = document.querySelector('#find-in-store-content .data span[data-size="' + value + '"]');
    if (fisContentStoreSpan) {
      let stores = String(fisContentStoreSpan.dataset.stores).split('***');
      
      if (stores.length == 1 && stores[0] == '') stores = null;

      if (stores) {
        stores.forEach(store => {
          let fisContentStoreDiv = document.querySelector('#find-in-store-content .stores > div[data-name="' + store + '"]');
          if (fisContentStoreDiv) fisContentStoreDiv.style.display = 'block';
        });
        fisContentResultsAvailable.style.display = 'block';
        fisContentResultsAvailableCount.textContent = stores.length;
        if (stores.length > 1) fisContentResultsAvailableS.style.display = 'inline';
      } else {
        fisContentResultsNotAvailable.style.display = 'block';
      }
    }
  }
}